export enum BrandingType {
  BoldChat,
  Bold360
}
